<label class="inline-flex items-center cursor-pointer">
  <input class="sr-only peer" type="checkbox" [checked]="checked" [disabled]="disabled" (change)="onToggle($event)">
  <div
    [class.opacity-50]="disabled"
    class="relative w-11 h-6 bg-blue-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600">
  </div>
</label>
